export default function formControlState({
  props,
  states,
  muiFormControl
}) {
  return states.reduce((acc, state) => {
    acc[state] = props[state];
    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }
    return acc;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ../@mui/material/FormControl/formControlState.js
// module id = 99
// module chunks = 22